
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/city-census",
      function () {
        return require("private-next-pages/city-census/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/city-census"])
      });
    }
  